import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, fromEvent, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Layout, NavigationExtras } from '../interfaces';

@Injectable({ providedIn: 'root' })
export class LayoutService {
  layout$ = new BehaviorSubject<Layout>(null);
  navigationExtras$ = new BehaviorSubject<NavigationExtras>(null);
  headerHeightChange$ = new BehaviorSubject<number>(0);
  headerCloseClicked$ = new Subject<void>();
  public headerResized$ = new Subject<void>();

  private headerHeight = 0;

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
    fromEvent(window, 'resize').subscribe(() => {
      this.updateHeaderHeight();
    });

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.getLayout();
        const state = this.router.getCurrentNavigation()?.extras?.state;
        this.navigationExtras$.next(state as NavigationExtras);
        this.updateHeaderHeight();
      });

    this.headerResized$.subscribe(() => {
      this.updateHeaderHeight();
    });
  }

  public headerCloseClick() {
    this.headerCloseClicked$.next();
  }

  public getHeaderHeight() {
    return this.headerHeight;
  }

  private updateHeaderHeight() {
    setTimeout(() => {
      const headerHeight = document.getElementById('header')?.offsetHeight;
      if (headerHeight !== this.headerHeight) {
        this.headerHeight = headerHeight;
        this.headerHeightChange$.next(this.headerHeight);
      }
    });
  }

  private getLayout() {
    let layout = null;
    let route = this.activatedRoute;
    while (route) {
      if (route.snapshot?.data?.layout) {
        layout = route.snapshot?.data?.layout;
      }
      if (route.snapshot?.data?.footer) {
        layout = { ...layout, footer: route.snapshot?.data?.footer };
      }
      if (route.snapshot?.data?.layout === 'bottomOffset') {
        layout = {
          ...layout,
          footer: {
            ...layout?.footer,
            bottomOffset: 'product',
          },
        };
      }
      if (route.snapshot?.data?.layout === 'simpleAlternativeShipping') {
        layout = {
          ...layout,
          footer: {
            ...layout?.footer,
            bottomOffset: 'checkout',
          },
        };
      }
      route = route.firstChild;
    }
    this.layout$.next(layout);
  }
}
